import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules'

const SwiperQuotes = () => {
    return (
        <div className="
        w-full
        lg:w-[70%]
        ">
            <Swiper slidesPerView={1.5} loop={true} centeredSlides={true} spaceBetween={20} className='w-full' autoplay={{delay:2000}} modules={[Autoplay]} speed={1500}>
                <SwiperSlide >
                    <div className='teal--quote bg-teal-700  cursor-pointer 
                    w-[80%] p-2
                    md:w-[400px]
                    lg:w-[350px]
                    xl:w-[530px] lg:p-14
                    min-[1290px]:w-[540px]
                    min-[1540px]:w-[630px]
                    2xl:w-[700px]
                    '>
                        <p className='text-black font-bold uppercase Haptik
                        text-[10px]
                        sm:text-[15px]
                        lg:text-[20px]
                        xl:text-4xl
                        '>Every idea choice we make is a step toward pushing the boundaries of what technology can achieve, and that's what excites me every day.</p>
                        <p className='text-white tracking-wider Haptik mt-6
                        text-[10px]
                        lg:text-base
                        '>Pritish Sinha - Lead Developer at Avirbhaav</p>
                    </div>
                </SwiperSlide>
                <SwiperSlide >
                    <div className='red--quote bg-red-700  cursor-pointer 
                    w-[80%] p-2
                    md:w-[400px]
                    lg:w-[350px]
                    xl:w-[530px] lg:p-14
                    min-[1290px]:w-[540px]
                    min-[1540px]:w-[630px]

                    2xl:w-[700px]
                    '>
                        <p className='text-black font-bold uppercase Haptik
                        text-[10px]
                        sm:text-[15px]
                        lg:text-[20px]
                        xl:text-4xl
                        '>The ideas from this team highlight how upcoming startups and developers should focus on the public's needs and the potential for innovation through incremental steps.</p>
                        <p className='text-white tracking-wider Haptik mt-6
                        text-[10px]
                        lg:text-base
                        '>Amitanshu Pattanaik - Senior Scientist at DRDO                        </p>
                    </div>
                </SwiperSlide>
                <SwiperSlide >
                    <div className='orange--quote bg-orange-700  cursor-pointer mb-4
                    w-[80%] p-2
                    md:w-[400px]
                    lg:w-[350px]
                    xl:w-[530px] lg:p-14
                    min-[1290px]:w-[540px]
                    min-[1540px]:w-[630px]

                    2xl:w-[700px]
                    '>
                        <p className='text-black font-bold uppercase Haptik
                        text-[10px]
                        sm:text-[15px]
                        lg:text-[20px]
                        xl:text-4xl
                        '>Each movement tells a story, and every frame is a canvas for magic and wonder.</p>
                        <p className='text-white tracking-wider Haptik mt-6
                        text-[10px]
                        lg:text-base
                        '>Dikshant Tyagi - Lead ...</p>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
}
 
export default SwiperQuotes;